module.exports = __webpack_public_path__ + "img/dot-loader.d864a642.gif";